import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from '@/components/Ad/Properties/PropertiesItem.styles';
import { AdProperty } from '@/api/types/ads.types';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { buildTestId } from '@/components/Ad/Properties/PropertiesItem.helpers';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

interface Props {
  adProperty?: AdProperty;
}

export const PropertiesItem: React.FC<Props> = ({ adProperty }) => {
  const { t } = useTranslation();

  if (!adProperty) {
    return (
      <S.Box data-testid="properties-item-skeleton-loader">
        <SkeletonLoader height="18px" />
        <SkeletonLoader height="18px" />
      </S.Box>
    );
  }

  if (adProperty.value === t('common.no')) {
    return null;
  }

  return (
    <S.Box data-testid={buildTestId(adProperty.name)}>
      <S.Label $variant="1" data-testid={buildTestId(adProperty.name, 'label')}>
        {adProperty.name}
      </S.Label>

      <S.Value
        $isLink={!!adProperty.link}
        {...(adProperty.link
          ? {
              href: adProperty.link,
              as: CustomLink,
              dataTestId: buildTestId(adProperty.name, 'value'),
            }
          : {
              $variant: '1',
              'data-testid': buildTestId(adProperty.name, 'value'),
            })}
      >
        {adProperty.value}
      </S.Value>
    </S.Box>
  );
};
